import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { useEffect, useState, useLayoutEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SAAGrid from "./components/saa/SAAGrid";
import { SITE, applySiteShell } from "./lib/site";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};
import AdminHub from "./pages/AdminHub";
import PrepPodAdmin from "./pages/PrepPodAdmin";
import AdminUsers from "./pages/AdminUsers";
import StaffRoom from "./pages/StaffRoom";
import { ForumHub, ForumBoard, ForumThread } from "./pages/Forum";
import Dashboard from "./pages/Dashboard";
import SoloEnroll from "./pages/SoloEnroll";
import SoloPreview from "./pages/SoloPreview";
import SoloLanding from "./pages/SoloLanding";
import TestOut from "./pages/TestOut";
import AthleteDashboard from "./pages/AthleteDashboard";
import HeadCoachDashboard from "./pages/HeadCoachDashboard";
import SoloLesson from "./pages/SoloLesson";
import SoloCourse from "./pages/SoloCourse";
import { ScholarshipRoster, ScholarOrientation } from "./pages/ScholarshipOrientation";
import StripeLinksAdmin from "./pages/StripeLinksAdmin";
import VoiceCheck from "./pages/VoiceCheck";
import FamilyPay from "./pages/FamilyPay";
import FuelLanding from "./pages/FuelLanding";
import FuelSuccess from "./pages/FuelSuccess";
import KitchenAdmin from "./pages/KitchenAdmin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import PricingPolicy from "./pages/PricingPolicy";
import AcademyAbout from "./pages/AcademyAbout";
import AdminOffers from "./pages/AdminOffers";
import Academy from "./pages/Academy";
import PrepPod from "./pages/PrepPod";
import PrepPodSuccess from "./pages/PrepPodSuccess";
import Pros from "./pages/Pros";
import CoachMeeting from "./pages/CoachMeeting";
import CoachMeetingAdmin from "./pages/CoachMeetingAdmin";
import B2Rsvp from "./pages/B2Rsvp";
import B2RsvpAdmin from "./pages/B2RsvpAdmin";
import AcademySuccess from "./pages/AcademySuccess";
import AcademyEnroll from "./pages/AcademyEnroll";
import AcademyApplyComingSoon from "./pages/AcademyApplyComingSoon";
import EnrollmentPortal from "./pages/enrollment/EnrollmentPortal";
import PaymentReturn from "./pages/enrollment/PaymentReturn";
import EnrollmentAdmin from "./pages/enrollment/EnrollmentAdmin";
import AcademyStart from "./pages/AcademyStart";
import AcademyEnrollmentSuccess from "./pages/AcademyEnrollmentSuccess";
import AcademyDashboard from "./pages/AcademyDashboard";
import AcademyAdminPortal from "./pages/AcademyAdminPortal";
import AcademyLMS from "./pages/AcademyLMS";
import AcademyCreateAccount from "./pages/AcademyCreateAccount";
import AcademyLogin from "./pages/AcademyLogin";
import AcademyForgotPassword from "./pages/AcademyForgotPassword";
import AcademyResetPassword from "./pages/AcademyResetPassword";
import TeacherPortal from "./pages/TeacherPortal";
import TeacherDashboard from "./pages/TeacherDashboard";
import Gradebook from "./pages/Gradebook";
import MoneyMoves from "./pages/MoneyMoves";
import ScopeSequence from "./pages/ScopeSequence";
import PreRegister from "./pages/PreRegister";
import PreRegisterSuccess from "./pages/PreRegisterSuccess";
import TuitionBalance from "./pages/TuitionBalance";
import PreRegisterAdmin from "./pages/PreRegisterAdmin";
import LessonPlanLookAhead from "./pages/LessonPlanLookAhead";
import PrsvrAssessments from "./pages/PrsvrAssessments";
import CalendarSelection from "./pages/CalendarSelection";
import KindergartenDashboard from "./pages/KindergartenDashboard";
import HighPerformanceDashboard from "./pages/HighPerformanceDashboard";
import FilmRoom from "./pages/FilmRoom";
import TheVault from "./pages/TheVault";
import LegacyDiagnostic from "./pages/LegacyDiagnostic";
import ParentDiagnostic from "./pages/ParentDiagnostic";
import AssessmentResults from "./pages/AssessmentResults";
import PerformersAudit from "./pages/PerformersAudit";
import ExecutiveReadinessReport from "./pages/ExecutiveReadinessReport";
import Electives from "./pages/Electives";
import AcademyStore from "./pages/AcademyStore";
import AdminStoreConfig from "./pages/AdminStoreConfig";
import ElectiveCourses from "./pages/ElectiveCourses";
import ElectiveCourse from "./pages/ElectiveCourse";
import FieldTripDetail from "./pages/FieldTripDetail";
import Orientation from "./pages/Orientation";
import PayTuition from "./pages/PayTuition";
import PartyRSVP from "./pages/PartyRSVP";
import AnnouncementAdmin from "./pages/AnnouncementAdmin";
import ScholarPortfolio from "./pages/ScholarPortfolio";
import ParentWelcome from "./pages/ParentWelcome";
import CoachsPlaybook from "./pages/CoachsPlaybook";
import MentalArmor from "./pages/MentalArmor";
import BasketballIQ from "./pages/BasketballIQ";
import BasketballIQGlossary from "./pages/BasketballIQGlossary";
import BasketballIQTerm from "./pages/BasketballIQTerm";
import BasketballIQCourse from "./pages/BasketballIQCourse";
import BasketballIQCourseModule from "./pages/BasketballIQCourseModule";
import FamilyHub from "./pages/FamilyHub";
import ElectiveReservationSuccess from "./pages/ElectiveReservationSuccess";
import NotFound from "./pages/NotFound";
import AdminCommunications from "./pages/AdminCommunications";
import TheCombine from "./pages/TheCombine";
import CombinePractice from "./pages/CombinePractice";
import GrandmasterSeries from "./pages/ThirtDaySprintEnrollment";
import Reclassification101 from "./pages/Reclassification101";
import LChaimLanding from "./pages/LChaimLanding";
import LChaimDashboard from "./pages/LChaimDashboard";
import LChaimPreview from "./pages/LChaimPreview";
import LChaimVault from "./pages/LChaimVault";
import LChaimEnroll from "./pages/LChaimEnroll";
import LChaimCompanion from "./pages/LChaimCompanion";
import LChaimSuccess from "./pages/LChaimSuccess";
import LChaimLinkAccount from "./pages/LChaimLinkAccount";
import LChaimLogin from "./pages/LChaimLogin";
import HeyGenAdmin from "./pages/HeyGenAdmin";
import SchoolDashboard from "./pages/SchoolDashboard";
import AdminMorningReport from "./pages/AdminMorningReport";
import ParentPortal from "./pages/ParentPortal";
import LessonPage from "./pages/LessonPage";
import NoahsArkReel from "./pages/NoahsArkReel";
import EnrollmentRecordsAdmin from "./pages/EnrollmentAdmin";
import ApexLanding from "./pages/ApexLanding";
import ApexCourse from "./pages/ApexCourse";
import ApexLesson from "./pages/ApexLesson";
import ApexQuiz from "./pages/ApexQuiz";
import ApexBioOptimizer from "./pages/ApexBioOptimizer";
import ApexCoachEmail from "./pages/ApexCoachEmail";
import CoppaVerify from "./pages/CoppaVerify";
import CoppaVerifySuccess from "./pages/CoppaVerifySuccess";

// Launch date: January 8th, 2026 @ 9:00 AM EST
const LAUNCH_DATE = new Date('2026-01-08T09:00:00-05:00');

// Gated Launch Wrapper - redirects logged-in users to waiting room before launch
const GatedLaunchWrapper = ({ children }) => {
  const location = useLocation();
  const [isBeforeLaunch, setIsBeforeLaunch] = useState(true);
  
  useEffect(() => {
    const checkLaunch = () => {
      const now = new Date();
      setIsBeforeLaunch(now < LAUNCH_DATE);
    };
    
    checkLaunch();
    const interval = setInterval(checkLaunch, 1000);
    return () => clearInterval(interval);
  }, []);

  // Pages that should bypass the gated launch redirect
  const bypassPaths = [
    '/welcome-jan-8',
    '/academy/enroll',
    '/academy/login',
    '/academy/create-account',
    '/academy/enrollment/success',
    '/academy/success',
    '/academy/legacy-diagnostic',
    '/academy/assessment-results',
    '/academy/family',
    '/academy/welcome',
    '/academy', // Landing page
    '/', // Homepage
    '/shop',
    '/about',
    '/collections',
    '/celebrities',
    '/privacy-policy',
    '/terms-of-service',
    '/refund-policy',
    '/pricing-policy',
    '/products',
    '/customize',
    '/admin',
    '/thank-you'
  ];
  
  // Check if current path should bypass
  const shouldBypass = bypassPaths.some(path => 
    location.pathname === path || 
    location.pathname.startsWith(path + '/')
  );

  // If before launch and user is logged in and trying to access gated content
  if (isBeforeLaunch && !shouldBypass) {
    const token = localStorage.getItem('academy_token');
    const userStr = localStorage.getItem('academy_user');
    
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        const isEnrolled = user.is_student || user.payment_status === 'paid' || user.subscription_tier;
        
        // WelcomeJan8 redirect stripped (school-only build) — let users through
      } catch (e) {
        // Invalid user data, let them through
      }
    }
  }

  return children;
};

// Suppress the global store Header/Footer on the DILA storefront, which has its
// own nav and its own Shopify-connected cart drawer.
const Chrome = ({ children }) => {
  const location = useLocation();
  const bare = location.pathname.startsWith('/dila') || location.pathname.startsWith('/chila') || location.pathname.startsWith('/road-to-michigan') || location.pathname.startsWith('/track') || location.pathname.startsWith('/admin/orders') || location.pathname.startsWith('/admin/run') || location.pathname.startsWith('/reel') || location.pathname.startsWith('/prep-pod');
  // L'Chaim has its own committed navy+cyan background — do not layer the
  // orange SAA grid on top of it or the palettes collide.
  const isLChaim = location.pathname.startsWith('/academy/lchaim');
  const showGrid = !bare && !isLChaim;
  return (
    <>
      {showGrid && <SAAGrid />}
      {!bare && <Header />}
      <main className={`flex-1 ${bare ? '' : 'pt-16'}`}>{children}</main>
      {!bare && <Footer />}
    </>
  );
};

function App() {
  useEffect(() => { applySiteShell(); }, []);
  return (
    <div className="App min-h-screen flex flex-col" style={{ overflowX: 'hidden', overflowY: 'visible' }}>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Chrome>
          <Routes>
            <Route path="/" element={<Navigate to="/academy" replace />} />
            <Route path="/login" element={<Navigate to="/academy/login" replace />} />
            <Route path="/home-legacy" element={<Navigate to="/academy" replace />} />
            <Route path="/saa" element={<Academy />} />
            <Route path="/admin" element={<AdminHub />} />
            <Route path="/admin/prep-pod" element={<PrepPodAdmin />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/stripe-links" element={<StripeLinksAdmin />} />
            <Route path="/admin/voice-check" element={<VoiceCheck />} />
            {/* FUEL by SAA — meal-prep ordering + kitchen ops */}
            <Route path="/fuel" element={<FuelLanding />} />
            <Route path="/fuel/success" element={<FuelSuccess />} />
            <Route path="/admin/kitchen" element={<KitchenAdmin />} />
            {/* Public direct-payment page — /pay/<family_key> — no login, no email gate */}
            <Route path="/pay/:familyKey" element={<FamilyPay />} />
            <Route path="/staff-room" element={<StaffRoom />} />
            <Route path="/community" element={<ForumHub />} />
            <Route path="/community/thread/:id" element={<ForumThread />} />
            <Route path="/community/:slug" element={<ForumBoard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/school/enroll" element={<Navigate to="/solo/enroll" replace />} />
            <Route path="/school/athlete" element={<Navigate to="/solo/athlete" replace />} />
            <Route path="/school/head-coach" element={<Navigate to="/solo/head-coach" replace />} />
            <Route path="/school/course/:courseId" element={<SoloCourse />} />
            <Route path="/school/lesson/:id" element={<SoloLesson />} />
            <Route path="/school/preview" element={<Navigate to="/solo/preview" replace />} />

            {/* SOLO — brand-isolated Autonomous School */}
            <Route path="/solo" element={<SoloLanding />} />
            <Route path="/solo/enroll" element={<SoloEnroll />} />
            <Route path="/solo/preview" element={<SoloPreview />} />
            <Route path="/solo/athlete" element={<AthleteDashboard />} />
            <Route path="/solo/head-coach" element={<HeadCoachDashboard />} />
            <Route path="/solo/course/:courseId" element={<SoloCourse />} />
            <Route path="/solo/lesson/:id" element={<SoloLesson />} />
            <Route path="/solo/test-out" element={<TestOut />} />
            {/* PRSVR Scholarship Orientation — DEPRECATED (kept as read-only route,
                redirects to standard orientation so the scholarship boys go
                through the same 5-quarter flow as every other family) */}
            <Route path="/academy/orientation/scholarship" element={<Navigate to="/academy/orientation" replace />} />
            <Route path="/academy/orientation/scholarship/:scholarKey" element={<Navigate to="/academy/orientation" replace />} />
            {/* Legacy /solo/scholarship-orientation URLs redirect */}
            <Route path="/solo/scholarship-orientation" element={<Navigate to="/academy/orientation" replace />} />
            <Route path="/solo/scholarship-orientation/:scholarKey" element={<Navigate to="/academy/orientation" replace />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/pricing-policy" element={<PricingPolicy />} />
            
            {/* Academy Routes */}
            <Route path="/academy" element={<Academy />} />
            <Route path="/prep-pod" element={<PrepPod />} />
            <Route path="/pod/success" element={<PrepPodSuccess />} />
            <Route path="/pros" element={<Pros />} />
            <Route path="/coach-meeting" element={<CoachMeeting />} />
            <Route path="/coach-meeting/admin" element={<CoachMeetingAdmin />} />
            <Route path="/22sports" element={<B2Rsvp />} />
            <Route path="/22sports/admin" element={<B2RsvpAdmin />} />
            <Route path="/academy/login" element={<AcademyLogin />} />
            <Route path="/academy/forgot-password" element={<AcademyForgotPassword />} />
            <Route path="/academy/reset-password" element={<AcademyResetPassword />} />
            <Route path="/academy/teacher" element={<TeacherPortal />} />
            <Route path="/academy/teacher/gradebook" element={<Gradebook />} />
            <Route path="/academy/teacher/scope" element={<ScopeSequence />} />
            <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
            <Route path="/teacher/lesson-plans" element={<LessonPlanLookAhead />} />
            <Route path="/academy/persona" element={<PrsvrAssessments />} />
            <Route path="/academy/calendar-selection" element={<CalendarSelection />} />
            <Route path="/school/kindergarten" element={<KindergartenDashboard />} />
            <Route path="/academy/success" element={<AcademySuccess />} />
            <Route path="/academy/enroll" element={<AcademyStart />} />
            <Route path="/academy/apply" element={<AcademyApplyComingSoon />} />
            {/* Merged enrollment portal (from github.com/brandoncwmson/enrollment-portal) */}
            <Route path="/preregister" element={<PreRegister />} />
            <Route path="/preregister/success" element={<PreRegisterSuccess />} />
            <Route path="/balance/:token" element={<TuitionBalance />} />
            <Route path="/preregister/admin" element={<PreRegisterAdmin />} />
            <Route path="/apply" element={<EnrollmentPortal />} />
            <Route path="/apply-comp" element={<EnrollmentPortal compFamily="general" compFamilyLabel="Comp Enrollment" />} />
            <Route path="/wilson-family" element={<EnrollmentPortal compFamily="wilson" compFamilyLabel="Wilson Family" />} />
            <Route path="/apply/payment-return" element={<PaymentReturn />} />
            <Route path="/apply/admin" element={<EnrollmentAdmin />} />
            <Route path="/academy/start" element={<AcademyStart />} />
            <Route path="/academy/enroll-paid" element={<AcademyEnroll />} />
            <Route path="/academy/enrollment/success" element={<AcademyEnrollmentSuccess />} />
            <Route path="/academy/lms" element={<AcademyLMS />} />
            <Route path="/academy/school" element={<SchoolDashboard />} />
            <Route path="/academy/lesson/:courseId/:moduleId" element={<LessonPage />} />
            <Route path="/academy/parent" element={<ParentPortal />} />
            <Route path="/academy/admin-portal" element={<AcademyAdminPortal />} />
            <Route path="/academy/create-account" element={<AcademyCreateAccount />} />
            
            {/* L'Chaim Routes */}
            <Route path="/academy/lchaim" element={<LChaimLanding />} />
            <Route path="/academy/lchaim/login" element={<LChaimLogin />} />
            <Route path="/academy/lchaim/dashboard" element={<LChaimDashboard />} />
            <Route path="/academy/lchaim/preview/:chord/:day" element={<LChaimPreview />} />
            <Route path="/academy/lchaim/vault" element={<LChaimVault />} />
            <Route path="/academy/lchaim/enroll" element={<LChaimEnroll />} />
            <Route path="/academy/lchaim/companion" element={<LChaimCompanion />} />
            <Route path="/academy/lchaim/success" element={<LChaimSuccess />} />
            <Route path="/academy/lchaim/link-account" element={<LChaimLinkAccount />} />
            
            {/* Client Brief Routes */}
            
            {/* Gated Launch - Waiting Room */}
            
            {/* Legacy Diagnostic & Assessment Results */}
            <Route path="/academy/legacy-diagnostic" element={<LegacyDiagnostic />} />
            <Route path="/academy/diagnostic" element={<LegacyDiagnostic />} />
            <Route path="/academy/parent-diagnostic" element={<ParentDiagnostic />} />
            <Route path="/academy/assessment-results" element={<AssessmentResults />} />
            <Route path="/academy/performers-audit" element={<PerformersAudit />} />
            <Route path="/academy/executive-report" element={<ExecutiveReadinessReport />} />
            
            {/* Academy About Page */}
            <Route path="/academy/about" element={<AcademyAbout />} />
            <Route path="/academy/reclassification-101" element={<Reclassification101 />} />
            
            {/* Electives */}
            <Route path="/academy/electives" element={<Electives />} />
            <Route path="/academy/electives/success" element={<ElectiveReservationSuccess />} />
            <Route path="/academy/money-moves" element={<MoneyMoves />} />
            <Route path="/academy/elective-courses" element={<ElectiveCourses />} />
            <Route path="/academy/elective-courses/:courseId" element={<ElectiveCourse />} />
            <Route path="/academy/field-trip/:tripId" element={<FieldTripDetail />} />

            {/* APEX Blueprint — Athletic Profile & Endorsement Exchange
                URL convention (applies to every SAA course going forward):
                  /{course}         = public landing (shareable, no auth)
                  /{course}/course  = the authenticated app
             */}
            <Route path="/apex" element={<ApexLanding />} />
            <Route path="/apex/course" element={<ApexCourse />} />
            <Route path="/apex/course/lesson/:lessonId" element={<ApexLesson />} />
            <Route path="/apex/course/quiz" element={<ApexQuiz />} />
            <Route path="/apex/course/tools/bio-optimizer" element={<ApexBioOptimizer />} />
            <Route path="/apex/course/tools/coach-email" element={<ApexCoachEmail />} />
            {/* Legacy /academy/apex* + /academy/nil* redirect to /apex/course* */}
            <Route path="/academy/apex" element={<Navigate to="/apex/course" replace />} />
            <Route path="/academy/apex/lesson/:lessonId" element={<Navigate to="/apex/course" replace />} />
            <Route path="/academy/apex/quiz" element={<Navigate to="/apex/course/quiz" replace />} />
            <Route path="/academy/nil" element={<Navigate to="/apex/course" replace />} />
            <Route path="/academy/nil/lesson/:lessonId" element={<Navigate to="/apex/course" replace />} />
            <Route path="/academy/nil/quiz" element={<Navigate to="/apex/course/quiz" replace />} />
            <Route path="/apex/coppa/verify" element={<CoppaVerify />} />
            <Route path="/apex/coppa/verify/success" element={<CoppaVerifySuccess />} />
            <Route path="/academy/coppa/verify" element={<Navigate to="/apex/coppa/verify" replace />} />
            <Route path="/academy/coppa/verify/success" element={<CoppaVerifySuccess />} />
            <Route path="/orientation" element={<Orientation />} />
            <Route path="/academy/orientation" element={<Orientation />} />
            <Route path="/pay-tuition" element={<PayTuition />} />
            <Route path="/academy/pay-tuition" element={<PayTuition />} />
            <Route path="/rsvp/handlelife-party" element={<PartyRSVP />} />
            <Route path="/academy/rsvp/handlelife-party" element={<PartyRSVP />} />
            <Route path="/coachs-playbook" element={<CoachsPlaybook />} />
            <Route path="/academy/coachs-playbook" element={<CoachsPlaybook />} />
            <Route path="/mental-armor" element={<MentalArmor />} />
            <Route path="/academy/mental-armor" element={<MentalArmor />} />
            <Route path="/basketball-iq" element={<BasketballIQ />} />
            <Route path="/academy/basketball-iq" element={<BasketballIQ />} />
            <Route path="/basketball-iq/glossary" element={<BasketballIQGlossary />} />
            <Route path="/basketball-iq/term/:slug" element={<BasketballIQTerm />} />
            <Route path="/basketball-iq/course" element={<BasketballIQCourse />} />
            <Route path="/basketball-iq/course/:slug" element={<BasketballIQCourseModule />} />
            <Route path="/football-iq" element={<BasketballIQ sport="football" />} />
            <Route path="/football-iq/glossary" element={<BasketballIQGlossary sport="football" />} />
            <Route path="/football-iq/term/:slug" element={<BasketballIQTerm sport="football" />} />
            <Route path="/football-iq/course" element={<BasketballIQCourse sport="football" />} />
            <Route path="/football-iq/course/:slug" element={<BasketballIQCourseModule sport="football" />} />
            <Route path="/soccer-iq" element={<BasketballIQ sport="soccer" />} />
            <Route path="/soccer-iq/glossary" element={<BasketballIQGlossary sport="soccer" />} />
            <Route path="/soccer-iq/term/:slug" element={<BasketballIQTerm sport="soccer" />} />
            <Route path="/soccer-iq/course" element={<BasketballIQCourse sport="soccer" />} />
            <Route path="/soccer-iq/course/:slug" element={<BasketballIQCourseModule sport="soccer" />} />
            <Route path="/track-iq" element={<BasketballIQ sport="track" />} />
            <Route path="/track-iq/glossary" element={<BasketballIQGlossary sport="track" />} />
            <Route path="/track-iq/term/:slug" element={<BasketballIQTerm sport="track" />} />
            <Route path="/track-iq/course" element={<BasketballIQCourse sport="track" />} />
            <Route path="/track-iq/course/:slug" element={<BasketballIQCourseModule sport="track" />} />
            <Route path="/academy/admin/announcement" element={<AnnouncementAdmin />} />
            <Route path="/academy/store" element={<AcademyStore />} />
            <Route path="/admin/store-config" element={<AdminStoreConfig />} />
            <Route path="/academy/portfolio/:slug" element={<ScholarPortfolio />} />
            <Route path="/academy/welcome" element={<ParentWelcome />} />
            <Route path="/academy/family" element={<FamilyHub />} />
            <Route path="/academy/family/:token" element={<FamilyHub />} />
            
            {/* Gated Academy Content - redirects to waiting room before launch */}
            <Route path="/academy/dashboard" element={<Navigate to="/academy/school" replace />} />
            <Route path="/student-dashboard" element={<Navigate to="/academy/school" replace />} />
            <Route path="/academy/high-performance" element={
              <GatedLaunchWrapper>
                <HighPerformanceDashboard />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/film-room" element={
              <GatedLaunchWrapper>
                <FilmRoom />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/vault" element={
              <GatedLaunchWrapper>
                <TheVault />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/combine" element={
              <GatedLaunchWrapper>
                <CombinePractice />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/grandmaster" element={
              <GatedLaunchWrapper>
                <GrandmasterSeries />
              </GatedLaunchWrapper>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/offers" element={<AdminOffers />} />
            <Route path="/admin/communications" element={<AdminCommunications />} />
            <Route path="/admin/heygen" element={<HeyGenAdmin />} />
            <Route path="/admin/morning-report" element={<AdminMorningReport />} />
            {/* Marketing Reel — auto-play Noah's Ark for screen-capture (bare, no chrome) */}
            <Route path="/reel/noahs-ark" element={<NoahsArkReel />} />
            <Route path="/academy/admin/enrollments" element={<EnrollmentRecordsAdmin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Chrome>
        </BrowserRouter>
        <Toaster position="top-right" />
      </CartProvider>
    </div>
  );
}

export default App;
